/* LUXBMX wishlist (replaces Swym Wishlist Plus).

   Loaded by sections/header.liquid only when the theme setting
   "Wishlist provider" is LUXBMX. Lists live in HUB and are reached through
   the Shopify app proxy at /apps/wishlist, which tells HUB who is logged in;
   a guest is a random token kept in this browser, and their lists move to
   their account the first time they call in logged in.

   What it drives:
   - every [data-lux-wl] heart (product cards, product page, quick view,
     Onyx builder): saved state, add and remove;
   - the header link's count bubble (.lux-wishlist-count);
   - the wishlist page ([data-lux-wl-page]): one tab per list (?list=ID
     opens a given list), Add all to cart, and a shared list when the URL
     carries ?share=CODE;
   - window.luxWishlist, which the Dream Build form reads lists from.

   Every name and title is written with textContent, never innerHTML: list
   names are typed by riders (the only innerHTML is two fixed icons). */
(function () {
    if (window.luxWishlist) return;

    var API = '/apps/wishlist/';
    var GUEST_KEY = 'lux-wl-guest';
    var IDS_KEY = 'lux-wl-ids';
    var IDS_TTL = 5 * 60 * 1000;
    var MAX_QTY = 99; /* HUB clamps to the same */
    var script = document.currentScript || document.querySelector('script[data-lux-wl-script]');
    var customerId = (script && script.getAttribute('data-customer')) || '';
    var loginUrl = (script && script.getAttribute('data-login-url')) || '/account/login';
    /* HUB emails price drops and restocks to logged-in riders (theme setting
       "Wishlist emails price drops and restocks", set with WISHLIST_ALERTS). */
    var alertsOn = !!(script && script.hasAttribute('data-alerts'));
    var money = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });

    function store(key, value) {
        try {
            if (value === undefined) return JSON.parse(localStorage.getItem(key) || 'null');
            if (value === null) localStorage.removeItem(key);
            else localStorage.setItem(key, JSON.stringify(value));
        } catch (e) { return null; }
        return null;
    }

    function guestToken() {
        var t = store(GUEST_KEY);
        if (typeof t === 'string' && /^[A-Za-z0-9_-]{24,64}$/.test(t)) return t;
        t = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now().toString(36) + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2));
        store(GUEST_KEY, t);
        return t;
    }

    function call(path, body) {
        var url = API + path + (path.indexOf('?') === -1 ? '?' : '&') + 'g=' + encodeURIComponent(guestToken());
        var opts = body
            ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), credentials: 'same-origin' }
            : { credentials: 'same-origin', cache: 'no-store' };
        return fetch(url, opts).then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (data) {
                if (!r.ok) throw new Error((data && data.error) || ('wishlist ' + r.status));
                return data;
            });
        });
    }

    /* ---------- saved ids (hearts + count) ---------- */

    var ids = null; /* [{ p, v, l }] */
    var listNames = []; /* [{ id, name, isDefault }] */
    var listeners = [];

    function cached() {
        var c = store(IDS_KEY);
        if (!c || c.customer !== customerId || Date.now() - c.at > IDS_TTL) return null;
        listNames = c.lists || [];
        return c.items;
    }
    function setIds(items, lists) {
        ids = items || [];
        if (lists) listNames = lists;
        store(IDS_KEY, { customer: customerId, at: Date.now(), items: ids, lists: listNames });
        listeners.forEach(function (fn) { try { fn(); } catch (e) {} });
    }
    function refreshIds() {
        return call('ids').then(function (d) { setIds(d.items, d.lists); return ids; });
    }
    function listName(id) {
        var l = listNames.filter(function (x) { return x.id === id; })[0];
        return l ? l.name : 'your wishlist';
    }
    function isSaved(productId, variantId) {
        if (!ids) return false;
        return ids.some(function (i) {
            return String(i.p) === String(productId) && (!variantId || String(i.v || '') === String(variantId));
        });
    }
    function count() {
        if (!ids) return 0;
        var seen = {};
        ids.forEach(function (i) { seen[i.p + ':' + (i.v || 0)] = 1; });
        return Object.keys(seen).length;
    }

    function report(action, p) {
        if (typeof window.luxWishlistReport === 'function') {
            try { window.luxWishlistReport(action, { variantId: p.variantId, productId: p.productId, sku: p.sku || null }); } catch (e) {}
        }
    }

    function add(p) {
        return call('add', { productId: p.productId, variantId: p.variantId || null, listId: p.listId || null, qty: p.qty || 1 })
            .then(function (r) { report('add', p); return refreshIds().then(function () { return r; }); });
    }
    function remove(p) {
        return call('remove', { productId: p.productId, variantId: p.variantId || null, listId: p.listId || null })
            .then(function (r) { report('remove', p); return refreshIds().then(function () { return r; }); });
    }

    /* ---------- hearts ---------- */

    /* The variant a heart stands for right now: a product page heart follows
       the variant picker (the form's id input, or the buy grid's own
       [data-variant-id]); a card heart uses the variant it was rendered with. */
    function heartVariant(btn) {
        var formId = btn.getAttribute('data-form-id');
        var input = formId && document.querySelector('#' + CSS.escape(formId) + ' [name="id"]');
        if (!input) {
            var grid = btn.closest('.buy-grid');
            input = grid && grid.querySelector('[data-variant-id]');
        }
        return (input && input.value) || btn.getAttribute('data-variant-id') || null;
    }

    /* The quantity picked on the product page, so saving 36 spokes saves 36. */
    function heartQty(btn) {
        var formId = btn.getAttribute('data-form-id');
        var input = formId && document.querySelector('[name="quantity"][form="' + formId + '"], #' + CSS.escape(formId) + ' [name="quantity"]');
        if (!input) {
            var grid = btn.closest('.buy-grid');
            input = grid && grid.querySelector('[name="quantity"]');
        }
        var n = input ? parseInt(input.value, 10) : 1;
        return n > 1 ? Math.min(n, MAX_QTY) : 1;
    }

    /* The buy grid starts with no option chosen when there's a real choice
       (its button reads Choose Options) but still holds the first variant's
       id, so a heart tapped then would save a colour the rider never picked. */
    function choiceMissing(btn) {
        var grid = btn.closest('buy-grid');
        return !!(grid && typeof grid.isIncomplete === 'function' && grid.isIncomplete());
    }

    function paintHeart(btn) {
        var product = btn.getAttribute('data-product-id');
        var byVariant = btn.getAttribute('data-lux-wl') === 'variant';
        var on = !(byVariant && choiceMissing(btn)) && isSaved(product, byVariant ? heartVariant(btn) : null);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.classList.toggle('is-saved', on);
        var label = btn.querySelector('[data-lux-wl-label]');
        if (label) label.textContent = on ? 'Saved' : 'Add to wishlist';
        btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    }
    function paintAll() {
        document.querySelectorAll('[data-lux-wl]').forEach(paintHeart);
        document.querySelectorAll('.lux-wishlist-count').forEach(function (el) {
            var n = count();
            el.textContent = n ? String(n) : '';
        });
    }
    listeners.push(paintAll);

    /* The theme's drawers and popovers (the quick view) trap focus and close
       on any tap outside themselves, and the toast and the list picker live
       on <body>, so tapping Change list used to close the quick view behind
       it. While one is open, the toast and picker join its focus trap. */
    function joinOpenTraps() {
        var extras = [document.querySelector('.lux-wl-toast'), document.querySelector('.lux-wl-picker')]
            .filter(function (n) { return n && n.isConnected; });
        document.querySelectorAll('[open]').forEach(function (el) {
            var trap = el._focusTrap;
            if (trap && typeof trap.updateContainerElements === 'function') {
                try { trap.updateContainerElements([el].concat(extras)); } catch (e) {}
            }
        });
    }

    /* action: { label, run } adds a button (Change list), and keeps the
       toast up longer and while the pointer or focus is on it. */
    var toastTimer = null;
    function toast(text, link, action) {
        var el = document.querySelector('.lux-wl-toast');
        if (!el) {
            el = document.createElement('div');
            el.className = 'lux-wl-toast';
            el.setAttribute('role', 'status');
            document.body.appendChild(el);
            var hold = function () { clearTimeout(toastTimer); };
            var release = function () { toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2500); };
            el.addEventListener('mouseenter', hold);
            el.addEventListener('focusin', hold);
            el.addEventListener('mouseleave', release);
            el.addEventListener('focusout', release);
        }
        el.textContent = text + ' ';
        if (action) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'lux-wl-toast__action';
            b.textContent = action.label;
            b.addEventListener('click', function () { el.classList.remove('is-visible'); action.run(); });
            el.appendChild(b);
        }
        if (link) {
            var a = document.createElement('a');
            a.href = '/pages/wishlist';
            a.textContent = 'View wishlist';
            el.appendChild(a);
        }
        el.classList.add('is-visible');
        joinOpenTraps();
        clearTimeout(toastTimer);
        toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, action ? 6000 : 3500);
    }

    /* ---------- list picker (after a heart save) ---------- */

    function moveItem(p, from, to) {
        return add({ productId: p.productId, variantId: p.variantId, listId: to, qty: p.qty, sku: p.sku })
            .then(function () { return remove({ productId: p.productId, variantId: p.variantId, listId: from }); });
    }

    /* A native <dialog>: focus trap, Esc and backdrop for free, and the top
       layer keeps it above the loyalty panel, like the wishlist page guide. */
    function pickList(p, currentId) {
        var dlg = document.createElement('dialog');
        dlg.className = 'lux-wl-picker';
        dlg.setAttribute('aria-labelledby', 'lux-wl-picker-title');
        var title = document.createElement('h2');
        title.id = 'lux-wl-picker-title';
        title.className = 'heading h6 lux-wl-picker__title';
        title.textContent = 'Save to a list';
        dlg.appendChild(title);
        var close = function () { dlg.close(); };
        var done = function (to) {
            if (to === currentId) { close(); return; }
            dlg.querySelectorAll('button, input').forEach(function (n) { n.disabled = true; });
            moveItem(p, currentId, to)
                .then(function () { close(); toast('Moved to ' + listName(to) + '.', true); })
                .catch(function (err) { close(); toast((err && err.message) || 'That did not move. Please try again.', false); });
        };
        var choices = document.createElement('div');
        choices.className = 'lux-wl-picker__lists';
        listNames.forEach(function (l) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'lux-wl-picker__list' + (l.id === currentId ? ' is-current' : '');
            b.setAttribute('aria-pressed', l.id === currentId ? 'true' : 'false');
            b.textContent = l.name;
            b.addEventListener('click', function () { done(l.id); });
            choices.appendChild(b);
        });
        dlg.appendChild(choices);
        var form = document.createElement('form');
        form.className = 'lux-wl-picker__new';
        var input = document.createElement('input');
        input.type = 'text';
        input.maxLength = 60;
        input.placeholder = 'New list, e.g. Street build';
        input.setAttribute('aria-label', 'New list name');
        var create = document.createElement('button');
        create.type = 'submit';
        create.className = 'button button--secondary button--small';
        create.textContent = 'Create';
        form.appendChild(input);
        form.appendChild(create);
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            var name = input.value.trim();
            if (!name) { input.focus(); return; }
            create.disabled = true;
            call('lists/create', { name: name }).then(function (r) {
                listNames = listNames.concat([{ id: r.id, name: name, isDefault: false }]);
                done(r.id);
            }).catch(function (err) { create.disabled = false; toast((err && err.message) || 'Could not make that list.', false); });
        });
        dlg.appendChild(form);
        var cancel = document.createElement('button');
        cancel.type = 'button';
        cancel.className = 'link lux-wl-picker__cancel';
        cancel.textContent = 'Keep it where it is';
        cancel.addEventListener('click', close);
        dlg.appendChild(cancel);
        dlg.addEventListener('close', function () { dlg.remove(); joinOpenTraps(); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
        document.body.appendChild(dlg);
        joinOpenTraps();
        dlg.showModal();
    }

    document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-lux-wl]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        if (btn.getAttribute('aria-busy') === 'true') return;
        var product = btn.getAttribute('data-product-id');
        var byVariant = btn.getAttribute('data-lux-wl') === 'variant';
        if (byVariant && choiceMissing(btn)) {
            var grid = btn.closest('buy-grid');
            if (typeof grid.flashSelectLabels === 'function') grid.flashSelectLabels();
            toast('Choose your options first.', false);
            return;
        }
        var variant = heartVariant(btn);
        var on = isSaved(product, byVariant ? variant : null);
        btn.setAttribute('aria-busy', 'true');
        var p = { productId: product, variantId: on && !byVariant ? null : variant, sku: btn.getAttribute('data-sku'), qty: on ? 1 : heartQty(btn) };
        (on ? remove(p) : add(p))
            .then(function (r) {
                if (on) { toast('Removed from your wishlist.', false); return; }
                var to = r && r.listId;
                toast('Saved to ' + listName(to) + '.', true, to ? { label: 'Change list', run: function () { pickList(p, to); } } : null);
            })
            .catch(function () { toast('That did not save. Please try again.', false); })
            .then(function () { btn.removeAttribute('aria-busy'); paintAll(); });
    }, true);

    document.addEventListener('variant:changed', function () { setTimeout(paintAll, 30); }, true);
    new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
            var nodes = records[i].addedNodes;
            for (var j = 0; j < nodes.length; j++) {
                var n = nodes[j];
                if (n.nodeType === 1 && (n.matches('[data-lux-wl]') || n.querySelector('[data-lux-wl]'))) { paintAll(); return; }
            }
        }
    }).observe(document.documentElement, { childList: true, subtree: true });

    /* ---------- wishlist page ---------- */

    function el(tag, cls, text) {
        var n = document.createElement(tag);
        if (cls) n.className = cls;
        if (text != null) n.textContent = text;
        return n;
    }

    function notifyCart() {
        var routes = (window.themeVariables && window.themeVariables.routes) || {};
        var settings = (window.themeVariables && window.themeVariables.settings) || {};
        return fetch((routes.cartUrl || '/cart') + '.js').then(function (r) { return r.json(); }).then(function (cart) {
            var root = document.documentElement;
            root.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
            root.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, openMiniCart: settings.cartType === 'drawer' } }));
        }).catch(function () {});
    }

    /* An item goes straight to cart only when it is a live, in-stock variant
       whose product page asks for nothing first. needsOptions (from HUB)
       means a required product field, like a spoke length, which only the
       product page collects. */
    function canAdd(item) {
        return item.live !== false && item.available && !!item.variantId && !item.needsOptions;
    }
    function cartLine(item) {
        return { id: Number(item.variantId), quantity: item.qty || 1 };
    }
    function postCart(lines) {
        return fetch(((window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartAddUrl) || '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: lines })
        }).then(function (r) {
            if (!r.ok) return r.json().catch(function () { return {}; }).then(function (d) { throw new Error(d.description || 'Could not add'); });
            return r.json();
        });
    }

    function addToCart(item, btn) {
        btn.disabled = true;
        return postCart([cartLine(item)]).then(function () {
            btn.textContent = 'Added';
            return notifyCart();
        }).catch(function (err) {
            btn.disabled = false;
            toast(err.message || 'Could not add to cart.', false);
        });
    }

    /* One request for the whole list. Shopify turns the whole request down
       when any line fails (usually more than is in stock), so a failure
       retries line by line and keeps whatever does go in. */
    function addAllToCart(items, btn) {
        var ready = items.filter(canAdd);
        var skipped = items.length - ready.length;
        var label = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding...';
        return postCart(ready.map(cartLine)).then(function () {
            return { added: ready.length, failed: 0 };
        }).catch(function () {
            var result = { added: 0, failed: 0 };
            return ready.reduce(function (chain, item) {
                return chain.then(function () {
                    return postCart([cartLine(item)]).then(function () { result.added++; }, function () { result.failed++; });
                });
            }, Promise.resolve()).then(function () { return result; });
        }).then(function (r) {
            btn.disabled = false;
            btn.textContent = label;
            var left = skipped + r.failed;
            var text = r.added
                ? 'Added ' + r.added + (r.added === 1 ? ' item' : ' items') + ' to your cart.'
                : 'None of these could be added to your cart.';
            if (left) text += ' ' + left + (left === 1 ? ' item needs' : ' items need') + ' a look on its product page.';
            toast(text, false);
            if (r.added) return notifyCart();
        });
    }

    /* Item count, total and Add all to cart, above a list's items. The total
       is today's price of everything still on sale, at each item's quantity. */
    function buyBar(items) {
        var wrap = el('div', 'lux-wl-buy');
        var summary = el('p', 'lux-wl-buy__summary');
        wrap.refresh = function () {
            var total = items.reduce(function (sum, i) {
                return i.live !== false && i.price ? sum + Number(i.price) * (i.qty || 1) : sum;
            }, 0);
            summary.textContent = items.length + (items.length === 1 ? ' item' : ' items');
            if (total) {
                summary.appendChild(document.createTextNode(', '));
                summary.appendChild(el('strong', null, money.format(total)));
            }
        };
        wrap.refresh();
        wrap.appendChild(summary);
        var ready = items.filter(canAdd);
        if (ready.length) {
            var all = el('button', 'button button--primary button--small', ready.length === items.length ? 'Add all to cart' : 'Add ' + ready.length + ' to cart');
            all.type = 'button';
            all.addEventListener('click', function () { addAllToCart(items, all); });
            wrap.appendChild(all);
        }
        return wrap;
    }

    /* Quantity for one saved item. Each change lands on item.qty and calls
       onInput straight away (the total and Add all read it); onSave waits
       until the rider stops tapping. */
    /* The theme's quantity selector classes and icons (snippets/icon.liquid
       minus-big and plus-big), on a plain div so the theme's own
       <quantity-selector> behaviour stays out of it. */
    var QTY_ICONS = {
        minus: '<svg focusable="false" width="10" height="2" viewBox="0 0 10 2" aria-hidden="true"><path fill="currentColor" d="M0 0h10v2H0z"></path></svg>',
        plus: '<svg focusable="false" width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 6v4h2V6h4V4H6V0H4v4H0v2h4z" fill="currentColor"></path></svg>'
    };
    function qtyStepper(item, onInput, onSave) {
        var wrap = el('div', 'quantity-selector lux-wl-qty');
        var timer = null;
        var minus = el('button', 'quantity-selector__button');
        var input = el('input', 'quantity-selector__input');
        var plus = el('button', 'quantity-selector__button');
        minus.innerHTML = QTY_ICONS.minus;
        plus.innerHTML = QTY_ICONS.plus;
        minus.type = plus.type = 'button';
        minus.setAttribute('aria-label', 'Fewer');
        plus.setAttribute('aria-label', 'More');
        input.type = 'text';
        input.inputMode = 'numeric';
        input.setAttribute('aria-label', 'Quantity');
        function set(n, now) {
            n = Math.max(1, Math.min(MAX_QTY, parseInt(n, 10) || 1));
            input.value = String(n);
            minus.disabled = n <= 1;
            plus.disabled = n >= MAX_QTY;
            if (n === (item.qty || 1)) return;
            item.qty = n;
            onInput(n);
            clearTimeout(timer);
            timer = setTimeout(function () { onSave(n); }, now ? 0 : 500);
        }
        set(item.qty || 1);
        minus.addEventListener('click', function () { set((item.qty || 1) - 1); });
        plus.addEventListener('click', function () { set((item.qty || 1) + 1); });
        input.addEventListener('change', function () { set(input.value, true); });
        input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); input.blur(); } });
        wrap.appendChild(minus);
        wrap.appendChild(input);
        wrap.appendChild(plus);
        return wrap;
    }

    function itemCard(item, opts) {
        var card = el('div', 'lux-wl-item' + (item.live === false ? ' is-gone' : ''));
        var url = item.handle ? '/products/' + item.handle + (item.variantId ? '?variant=' + item.variantId : '') : null;
        var media = el(url ? 'a' : 'div', 'lux-wl-item__media');
        if (url) media.href = url;
        if (item.image) {
            var img = el('img');
            img.src = item.image;
            img.alt = '';
            img.loading = 'lazy';
            media.appendChild(img);
        }
        card.appendChild(media);
        var body = el('div', 'lux-wl-item__body');
        var title = el(url ? 'a' : 'p', 'lux-wl-item__title', item.title || 'No longer available');
        if (url) title.href = url;
        body.appendChild(title);
        var buyable = item.live !== false && item.available && !!item.variantId;
        var detail = [item.variantTitle, !buyable && item.qty > 1 ? 'Qty ' + item.qty : null].filter(Boolean).join(', ');
        if (detail) body.appendChild(el('p', 'lux-wl-item__variant', detail));
        if (item.price) {
            var price = el('p', 'lux-wl-item__price');
            var cmp = Number(item.compareAtPrice), now = Number(item.price);
            if (cmp > now) {
                var was = el('s', 'lux-wl-item__was', money.format(cmp));
                price.appendChild(was);
                price.appendChild(document.createTextNode(' '));
            }
            price.appendChild(document.createTextNode(money.format(now)));
            body.appendChild(price);
        }
        // Archive pieces (sold-out custom builds) come from HUB without a price.
        var stock = item.live === false ? 'No longer available' : item.archive ? 'Archive' : item.available ? '' : 'Sold out';
        if (stock) body.appendChild(el('p', 'lux-wl-item__stock', stock));
        if (alertsOn && opts.owner && item.live !== false && !item.available && !item.archive && item.variantId) {
            var back = el('p', 'lux-wl-item__alert');
            if (customerId) {
                back.textContent = "We'll email you when it's back.";
            } else {
                var login = el('a', null, 'Log in');
                login.href = loginUrl + '?return_url=' + encodeURIComponent('/pages/wishlist');
                back.appendChild(login);
                back.appendChild(document.createTextNode(" and we'll email you when it's back."));
            }
            body.appendChild(back);
        }
        /* Quantity and the buy button share a row; Move to and Remove sit under it. */
        var buy = el('div', 'lux-wl-item__buy');
        var optHref = null;
        if (buyable) {
            buy.appendChild(qtyStepper(item, function () {
                if (optHref) optHref();
                if (opts.onQty) opts.onQty();
            }, function (n) {
                if (!opts.owner) return;
                call('qty', { productId: item.productId, variantId: item.variantId, listId: opts.list.id, qty: n })
                    .catch(function () { toast('That quantity did not save. Please try again.', false); });
            }));
        }
        var actions = el('div', 'lux-wl-item__actions');
        if (canAdd(item)) {
            var atc = el('button', 'button button--primary button--small', 'Add to cart');
            atc.type = 'button';
            atc.addEventListener('click', function () { addToCart(item, atc); });
            buy.appendChild(atc);
        } else if (item.live !== false && item.available && item.needsOptions && url) {
            /* wl_qty carries the quantity to the product page's own picker. */
            var opt = el('a', 'button button--primary button--small', 'Choose options');
            optHref = function () { opt.href = url + ((item.qty || 1) > 1 ? (url.indexOf('?') === -1 ? '?' : '&') + 'wl_qty=' + item.qty : ''); };
            optHref();
            buy.appendChild(opt);
        } else if (item.live !== false && url) {
            var view = el('a', 'button button--secondary button--small', 'View');
            view.href = url;
            buy.appendChild(view);
        }
        if (opts.owner) {
            if (opts.lists && opts.lists.length > 1) {
                var move = el('select', 'lux-wl-item__move');
                move.setAttribute('aria-label', 'Move to another list');
                var first = el('option', null, 'Move to...');
                first.value = '';
                move.appendChild(first);
                opts.lists.forEach(function (l) {
                    if (l.id === opts.list.id) return;
                    var o = el('option', null, l.name);
                    o.value = l.id;
                    move.appendChild(o);
                });
                move.addEventListener('change', function () {
                    if (!move.value) return;
                    var to = move.value;
                    move.disabled = true;
                    add({ productId: item.productId, variantId: item.variantId, listId: to })
                        .then(function () { return remove({ productId: item.productId, variantId: item.variantId, listId: opts.list.id }); })
                        .then(opts.reload)
                        .catch(function () { move.disabled = false; toast('Could not move that item.', false); });
                });
                actions.appendChild(move);
            }
            var rm = el('button', 'lux-wl-item__remove link', 'Remove');
            rm.type = 'button';
            rm.addEventListener('click', function () {
                rm.disabled = true;
                remove({ productId: item.productId, variantId: item.variantId, listId: opts.list.id }).then(opts.reload)
                    .catch(function () { rm.disabled = false; });
            });
            actions.appendChild(rm);
        }
        if (buy.childNodes.length) body.appendChild(buy);
        if (actions.childNodes.length) body.appendChild(actions);
        card.appendChild(body);
        return card;
    }

    function shareUrl(list) {
        return location.origin + '/pages/wishlist?share=' + encodeURIComponent(list.shareCode);
    }

    /* The open list rides in the URL as ?list=ID, so a list can be linked
       to and a refresh stays on it. */
    function rememberList(id) {
        try {
            var u = new URL(location.href);
            if (id) u.searchParams.set('list', id); else u.searchParams.delete('list');
            history.replaceState(history.state, '', u.pathname + u.search + u.hash);
        } catch (e) {}
    }

    function renderOwner(root, state, activeId) {
        root.textContent = '';
        var lists = state.lists || [];
        var active = lists.filter(function (l) { return l.id === activeId; })[0] || lists[0];
        var reload = function () { return load(root, active && active.id); };
        rememberList(active && lists.length > 1 ? active.id : null);

        if (!state.customer) {
            var note = el('p', 'lux-wl-note');
            note.appendChild(document.createTextNode('Saved on this device. '));
            var a = el('a', null, 'Log in');
            a.href = loginUrl + '?return_url=' + encodeURIComponent('/pages/wishlist');
            note.appendChild(a);
            note.appendChild(document.createTextNode(' to keep your list on every device.'));
            root.appendChild(note);
        }

        var tabs = el('div', 'lux-wl-tabs');
        tabs.setAttribute('role', 'tablist');
        lists.forEach(function (l) {
            var t = el('button', 'lux-wl-tab' + (active && l.id === active.id ? ' is-active' : ''));
            t.type = 'button';
            t.setAttribute('role', 'tab');
            t.setAttribute('aria-selected', active && l.id === active.id ? 'true' : 'false');
            t.appendChild(document.createTextNode(l.name + ' '));
            t.appendChild(el('span', 'lux-wl-tab__count', String(l.items.length)));
            t.addEventListener('click', function () { renderOwner(root, state, l.id); });
            tabs.appendChild(t);
        });
        var newList = el('button', 'lux-wl-tab lux-wl-tab--new', '+ New list');
        newList.type = 'button';
        newList.addEventListener('click', function () {
            var name = window.prompt('Name your new list', 'Dream build');
            if (!name) return;
            call('lists/create', { name: name }).then(function (r) { return load(root, r.id); })
                .catch(function (err) { toast(err.message, false); });
        });
        tabs.appendChild(newList);
        root.appendChild(tabs);
        /* On phones the tabs scroll sideways; keep the open one in view. */
        var activeTab = tabs.querySelector('.is-active');
        if (activeTab && tabs.scrollWidth > tabs.clientWidth) tabs.scrollLeft = activeTab.offsetLeft - tabs.offsetLeft - 16;

        if (!active || !active.items.length) {
            var empty = el('div', 'lux-wl-empty');
            empty.appendChild(el('p', 'lux-wl-empty__title', 'Nothing saved yet'));
            empty.appendChild(el('p', null, 'Tap the heart on any part, bike or gear to save it here.'));
            var b = el('a', 'button button--primary', 'Plan a build in the bike builder');
            b.href = '/pages/build-your-bike';
            empty.appendChild(b);
            root.appendChild(empty);
        }

        if (active) {
            var bar = el('div', 'lux-wl-bar');
            var share = el('button', 'button button--secondary button--small', 'Share list');
            share.type = 'button';
            share.addEventListener('click', function () {
                var url = shareUrl(active);
                var done = function () { toast('Share link copied.', false); };
                if (navigator.share) navigator.share({ title: active.name, url: url }).catch(function () {});
                else if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link', url); });
                else window.prompt('Copy this link', url);
            });
            if (active.items.length) bar.appendChild(share);
            var rename = el('button', 'link', 'Rename');
            rename.type = 'button';
            rename.addEventListener('click', function () {
                var name = window.prompt('Rename this list', active.name);
                if (!name || name === active.name) return;
                call('lists/rename', { listId: active.id, name: name }).then(reload).catch(function (err) { toast(err.message, false); });
            });
            /* An empty default list has nothing to rename it for yet. */
            if (active.items.length || !active.isDefault) bar.appendChild(rename);
            var del = el('button', 'link', active.isDefault ? 'Clear list' : 'Delete list');
            del.type = 'button';
            del.addEventListener('click', function () {
                if (!window.confirm(active.isDefault ? 'Remove everything from this list?' : 'Delete "' + active.name + '"?')) return;
                call('lists/delete', { listId: active.id }).then(function () { return refreshIds(); }).then(function () { return load(root, null); });
            });
            if (active.items.length || !active.isDefault) bar.appendChild(del);
            if (bar.childNodes.length) root.appendChild(bar);

            if (active.items.length) {
                var ownBar = root.appendChild(buyBar(active.items));
                var grid = el('div', 'lux-wl-grid');
                active.items.forEach(function (it) {
                    grid.appendChild(itemCard(it, { owner: true, list: active, lists: lists, reload: reload, onQty: ownBar.refresh }));
                });
                root.appendChild(grid);
            }
        }
        root.removeAttribute('aria-busy');
    }

    function renderShared(root, data) {
        root.textContent = '';
        root.appendChild(el('h2', 'lux-wl-shared__title heading h5', data.name));
        if (!data.items.length) {
            root.appendChild(el('p', null, 'This list is empty.'));
        } else {
            var sharedBar = root.appendChild(buyBar(data.items));
            var grid = el('div', 'lux-wl-grid');
            data.items.forEach(function (it) { grid.appendChild(itemCard(it, { owner: false, onQty: sharedBar.refresh })); });
            root.appendChild(grid);
        }
        root.removeAttribute('aria-busy');
    }

    function load(root, activeId) {
        root.setAttribute('aria-busy', 'true');
        return call('state').then(function (state) {
            setIds([].concat.apply([], (state.lists || []).map(function (l) {
                return l.items.map(function (i) { return { p: i.productId, v: i.variantId, l: l.id }; });
            })), (state.lists || []).map(function (l) { return { id: l.id, name: l.name, isDefault: l.isDefault }; }));
            renderOwner(root, state, activeId);
        }).catch(function () {
            root.textContent = '';
            root.appendChild(el('p', 'lux-wl-note', 'Your wishlist did not load. Refresh the page to try again.'));
            root.removeAttribute('aria-busy');
        });
    }

    function initPage() {
        var root = document.querySelector('[data-lux-wl-page]');
        if (!root) return;
        var code = new URLSearchParams(location.search).get('share');
        if (code && /^[A-Za-z0-9]{6,20}$/.test(code)) {
            root.setAttribute('aria-busy', 'true');
            call('shared/' + code).then(function (d) { renderShared(root, d); }).catch(function () {
                root.textContent = '';
                root.appendChild(el('p', 'lux-wl-note', 'That shared list could not be found. It may have been deleted.'));
                root.removeAttribute('aria-busy');
            });
        } else if (root.getAttribute('data-share-page') === 'true') {
            root.textContent = '';
            root.appendChild(el('p', 'lux-wl-note', 'This shared list link is from our old wishlist and can no longer be opened. Ask for a new link from the list\'s owner.'));
            root.removeAttribute('aria-busy');
        } else {
            var listId = new URLSearchParams(location.search).get('list');
            load(root, listId && /^[0-9a-f-]{36}$/i.test(listId) ? listId : null);
        }
    }

    /* ---------- Dream Build form ---------- */

    /* The Dream Build form was written against Swym's API, so it gets lists
       in Swym's shape: lid / lname / listcontents with epi (variant), empi
       (product), dt (title), vi (variant title), pr (price), iu (image),
       du (url). lid is the list's id for a rider's own list; a pasted share
       link resolves by its share code. */
    function toSwymItem(i) {
        return {
            epi: i.variantId ? Number(i.variantId) : null,
            empi: Number(i.productId),
            dt: i.title || '',
            vi: i.variantTitle || '',
            pr: i.price ? Number(i.price) : 0,
            iu: i.image || '',
            du: i.handle ? location.origin + '/products/' + i.handle + (i.variantId ? '?variant=' + i.variantId : '') : '',
            qty: i.qty || 1,
            sku: i.sku || ''
        };
    }
    var lastState = null;
    var swymShim = {
        fetchLists: function (o) {
            call('state').then(function (s) {
                lastState = s;
                o.callbackFn((s.lists || []).map(function (l) {
                    return { lid: l.id, lname: l.name, listcontents: l.items.filter(function (i) { return i.live !== false; }).map(toSwymItem) };
                }));
            }).catch(function (e) { if (o.errorFn) o.errorFn(e); });
        },
        fetchListDetails: function (o, done, fail) {
            call('shared/' + encodeURIComponent(o.lid)).then(function (d) {
                done({ list: { lid: o.lid, lname: d.name, listcontents: d.items.filter(function (i) { return i.live !== false; }).map(toSwymItem) } });
            }).catch(function (e) { if (fail) fail(e); });
        },
        generateSharedListURL: function (lid, done, fail) {
            var l = lastState && (lastState.lists || []).filter(function (x) { return x.id === lid; })[0];
            if (l) done(shareUrl(l)); else if (fail) fail();
        }
    };

    window.luxWishlist = {
        add: add,
        remove: remove,
        isSaved: isSaved,
        refresh: refreshIds,
        lists: function () { return call('state'); },
        shared: function (code) { return call('shared/' + encodeURIComponent(code)); },
        shareUrl: shareUrl,
        swym: swymShim
    };

    var queued = window.LuxWishlistCallbacks || [];
    window.LuxWishlistCallbacks = { push: function (fn) { try { fn(window.luxWishlist); } catch (e) {} } };
    queued.forEach(function (fn) { try { fn(window.luxWishlist); } catch (e) {} });

    /* ---------- quantity from a wishlist link ---------- */

    /* "Choose options" on the wishlist links here with ?wl_qty=N so the
       product page's quantity picker starts at what the rider saved. */
    function applyLinkQty() {
        var n = parseInt(new URLSearchParams(location.search).get('wl_qty'), 10);
        if (!(n > 1)) return;
        document.querySelectorAll('.product-form__quantity [name="quantity"]').forEach(function (input) {
            input.value = String(Math.min(n, MAX_QTY));
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    /* ---------- start ---------- */

    applyLinkQty();
    ids = cached();
    if (ids) paintAll();
    if (document.querySelector('[data-lux-wl-page]')) initPage();
    else if (!ids) refreshIds().catch(function () { /* hearts just show unsaved */ });
})();
